import qs from 'qs'
import { useLocation } from '@reach/router'
import { useReferalParameterStore } from '../../youtalk-storybook/src/ui'

export const useSaveReferalParameter = (name) => {
  const location = useLocation()
  const searchObj = qs.parse(location?.search, { ignoreQueryPrefix: true })
  return useReferalParameterStore(name, searchObj[name])
}
